import React from 'react';

import config from '@shared/config';

import logo from '/logo.png';


interface LogoProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {};

export const Logo: React.FC<LogoProps> = (props) => {
  return (
    <img {...props} src={logo} alt={config.projectName}/>
  );
};
